import React from "react";

import VollmachtRequestFormJP from "../VollmachtRequestFormJp";

const LegalPersonVollmachtTab = (props) => {
  // Simple wrapper - just pass through to VollmachtRequestFormJp
  // VollmachtRequestFormJp handles all the logic for QES vs file upload
  return <VollmachtRequestFormJP {...props} />;
};

export default LegalPersonVollmachtTab;
